export function hasOneShowingChildren (children) {
  const showingChildren = children.filter(item => {
    return !item.hidden
  })
  if (showingChildren.length === 1) {
    return true
  }
  return false
}
